/** ボトムメニュー直上（BottomNav が :root に書く実測高さ） */
export const MOBILE_SHEET_BOTTOM_OFFSET = 'var(--kotomil-bottom-nav-height, 6rem)';

/** ボトムシートの展開スナップは計測コンテナ高の最大この割合まで（トライアル帯下のエリア基準・7割） */
export const MOBILE_ANALYSIS_SHEET_EXPANDED_MAX_FRACTION = 0.7;

/**
 * ボトムシートの Z 順。トライアル帯（z-40）より手前。BottomNav（z-[100]）より奥（全面でナビが隠れないように）。
 */
export const MOBILE_ANALYSIS_SHEET_STACKING = 'z-[50]';
